import React from 'react';

import { lookupCountry, type Geo } from './geo';

/**
 * Resolve a session's IP to its country for display. Wraps the cached, deduped
 * `lookupCountry` so each row can resolve its own IP independently while sharing
 * the module-level cache. Safe against unmount (ignores a late resolve) and
 * re-resolves when the IP changes.
 */
export const useSessionGeo = (ip?: string | null): { geo: Geo | null; loading: boolean } => {
  const [geo, setGeo] = React.useState<Geo | null>(null);
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!ip) {
      setGeo(null);
      setLoading(false);
      return;
    }
    let active = true;
    setLoading(true);
    setGeo(null);
    lookupCountry(ip)
      .then((result) => {
        if (!active) return;
        setGeo(result);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setGeo(null);
        setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [ip]);

  return { geo, loading };
};
